import type { ReactNode } from "react";
import css from "./InfoBox.module.css";

export function InfoBox(props: { title?: string; children: ReactNode }) {
  return (
    <div className={css.root}>
      {props.title && <div className={css.title}>{props.title}</div>}
      {props.children}
    </div>
  );
}
